import { render } from "./RegionItems.vue?vue&type=template&id=a247d826&scoped=true"
import script from "./RegionItems.vue?vue&type=script&lang=js"
export * from "./RegionItems.vue?vue&type=script&lang=js"

import "./RegionItems.vue?vue&type=style&index=0&id=a247d826&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a247d826"]])

export default __exports__